<script setup>
import BaseHeader from "@/components/base/base-header.vue";
import {useAppStore} from "@/stores/app.js";
import {computed, onMounted} from "vue";
import BaseAuth from "@/components/base/base-auth.vue";
import LoginForm from "@/components/forms/login-form.vue";
import RegisterForm from "@/components/forms/register-form.vue";
import ForgotForm from "@/components/forms/forgot-form.vue";
import BaseFooter from "@/components/base/base-footer.vue";
import {useAuthStore} from "@/stores/auth.js";
import {useRoute, useRouter} from "vue-router";
import {useCompanyStore} from "@/stores/company.js";
import {Auth} from "@/core/api/auth.js";
import {Processes} from "@/core/api/processes.js";
import {Orders} from "@/core/api/orders.js";
import {useCartStore} from "@/stores/cart.js";
import NewPasswordForm from "@/components/forms/new-password-form.vue";

const route = useRoute()
const router = useRouter()
const appStore = useAppStore()
const cartStore = useCartStore()
const authStore = useAuthStore()
const companyStore = useCompanyStore()

const activeState = computed(() => {
  return appStore.activeState
})

const checkUserAuth = async () => {
  const [res, companyRes] = await Promise.all([Auth.refresh(), Processes.getCompanyInfo()]);

  if (res) {
    authStore.setUser({
      user: res.data.refreshJwtToken.user,
      accessToken: res.data.refreshJwtToken.accessToken
    })

    // if (res.data.refreshJwtToken.user.language !== translation.currentLocale) {
    //   translations.switchLanguage(res.data.refreshJwtToken.user.language)
    //   await router.push({
    //     name: route.name,
    //     params: {
    //       locale: localStorage.getItem('gce-user-locale') || 'en-gb'
    //     }
    //   })
    // }

    localStorage.setItem('gce-refresh', res.data.refreshJwtToken.refreshToken)

    const currentOrder = await Orders.getOrders("PENDING", res.data.refreshJwtToken.accessToken, res.data.refreshJwtToken.user.email)
    cartStore.setCurrentOrders(currentOrder.data.orders.edges[0].node)
  }

  if (companyRes) {
    companyStore.setCompanyInfo(companyRes.data.parameters)
  }
}

onMounted(async () => {
  await checkUserAuth()

  setInterval(async () => {
    await checkUserAuth()
  }, 600000)
})
</script>

<template>
  <div class="main">
    <base-header />
    <Transition name="opacity" mode="out-in">
      <base-auth v-if="activeState">
        <login-form v-if="activeState === 'signIn'" />
        <register-form v-if="activeState === 'signUp'" />
        <forgot-form v-if="activeState === 'forgot'" />
        <new-password-form v-if="activeState === 'reset'" />
      </base-auth>
    </Transition>
    <RouterView v-slot="{ Component }" id="top">
      <Transition name="opacity" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
    <base-footer />
  </div>
</template>

<style lang="scss">
.main {
  transition: 0.2s;
  padding-top: 92px;
}

.notification {

}
</style>
